import styled from 'styled-components'
import { Grid } from '../../components/Grid'
import { ComponentLayout } from '../../components/layouts/ComponentLayout'
import { QuestionSkeleton } from '../../components/QuestionSkeleton'
import { Title1, Title6 } from '../../components/styles/Typography'
import { theme } from '../../theme/theme'
import { ScreeningHeader } from '../../components/screening/ScreeningHeader'
import { useState } from 'react'
import { OnClickButton } from '../../components/buttons/onclick/OnClickButton'

export const Miscellaneous = () => {
  const [progress, setprogress] = useState(50)

  return (
    <ComponentLayout>
      <StyledTitle1>Miscellaneous</StyledTitle1>
      <StyledTitle6>Progress bar</StyledTitle6>
      <Grid $columns={1}>
        <ScreeningHeader title="Screening header" goBack={() => null} progress={progress} />
        <ButtonContainer>
          <OnClickButton
            text="- progress"
            onClick={() => {
              setprogress(progress - 10)
            }}
          />
          <OnClickButton
            text="+ progress"
            onClick={() => {
              setprogress(progress + 10)
            }}
          />
        </ButtonContainer>
      </Grid>
      <StyledTitle6>Screening question skeleton</StyledTitle6>
      <Grid $columns={2}>
        <QuestionSkeleton />
      </Grid>
    </ComponentLayout>
  )
}

const ButtonContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.medium}px;
  margin-bottom: ${theme.spacing.jumbo}px;
  justify-content: center;
`
const StyledTitle1 = styled(Title1)`
  margin-bottom: ${theme.spacing.large}px;
`
const StyledTitle6 = styled(Title6)`
  margin-top: ${theme.spacing.medium}px;
  margin-bottom: ${theme.spacing.medium}px;
  text-transform: uppercase;
`
